import { render, staticRenderFns } from "./PanelService.vue?vue&type=template&id=328fff1e"
import script from "./PanelService.vue?vue&type=script&lang=js"
export * from "./PanelService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports